/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import AppRouter from 'app/backbone/lib/routers/app_router';
import { MnObject } from 'backbone.marionette';
import { app as App } from 'app/backbone/app';

class Router extends AppRouter {
  initialize({ controller }) {
    this.controller = controller;
    super.initialize(...arguments); // eslint-disable-line prefer-rest-params
  }

  chooseNav() {
    return App.getChannel().trigger('nav:choose', 'certificates');
  }
}

const controller = {};

const API = MnObject.extend({
  channelName: 'router',

  radioRequests: {
    'app:certificates': 'listCertificates'
  },

  listCertificates() {
    Router.prototype.before();
    App.navigate('certificates');
    App.getChannel().request('enable:org_filter', true);
  }
});

export const certificates = new API();

const CertificatesApp = {
  start() {
    return new Router({
      controller
    });
  }
};

export default CertificatesApp;
